"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowCounter = void 0;
const interval_time_1 = require("./interval_time");
class WindowCounter {
    constructor(windowDuration, queue = []) {
        this.windowDuration = windowDuration;
        this.queue = queue;
    }
    static deserialize(serializedValue) {
        const parsed = JSON.parse(serializedValue);
        return new WindowCounter(parsed.windowDuration, parsed.queue?.map((d) => new Date(d)));
    }
    getCount() {
        this.dropOldTimestamps();
        return this.queue.length;
    }
    increment() {
        this.dropOldTimestamps();
        this.queue.push(new Date());
    }
    dropOldTimestamps() {
        const afterTimestamp = (0, interval_time_1.decreaseTimeByDelta)(new Date(), this.windowDuration);
        this.queue = this.queue.filter((date) => date > afterTimestamp);
    }
}
exports.WindowCounter = WindowCounter;
